export const AUTH_SUB_PAGES = {
  verification: 'verification',
  validation: 'validation',
  forgotPassword: 'forgotPassword',
  resetPassword: 'resetPassword',
  signUp: 'signUp',
  welcome: 'welcome',
};

export const PASSWORD_PATTERN = '^(?=.*[A-Z])(?=.*[@$!%*?&\\d])[A-Za-z0-9\\d@$!%*?&]{8,30}$';
